<template>
  <div v-if="comparison.a || comparison.b" id="compare-kicker" class="bg-primary py-1">
    <div class="container">
      <div class="d-flex justify-content-between">
        <button class="d-block border-0 bg-transparent text-white text-uppercase fw-bold caret-up" data-bs-toggle="offcanvas" data-bs-target="#compare-drawer" aria-controls="compare-drawer">
          <slot name="product-compare-kicker-title"></slot>
        </button>
        <button class="d-block border-0 bg-transparent text-white" aria-label="close" @click="$emit('clearComparison')">
          <slot name="product-compare-kicker-close"></slot>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['comparison'],
  emits: ['clearComparison']
}
</script>